module.exports = "https://web-assets.ifttt.com/packs/media/social-signon/facebook-ea91d8a8.svg";